import * as apiBff from './bff'

export async function getDepartments<T>(season: string, universeId: number): Promise<T> {
  return apiBff.callBFF<T>('GET', `season/${season}/universes/${universeId}`)
}
